// Centralized pricing configuration
// Update prices here and they will reflect across the entire application

export const CURRENCY = '$';
export const CURRENCY_CODE = 'USD';

export const CREDIT_PACKAGES = [
  { credits: 100, price: 15, original_price: 25, name: 'Starter', badge: '' },
  { credits: 250, price: 37, original_price: 60, name: 'Growth', badge: 'Most Popular' },
  { credits: 500, price: 70, original_price: 120, name: 'Pro', badge: 'Best Value' }
];

// Starting price for FAQ and marketing materials
export const STARTING_PRICE = 15;
